class PopupMessage {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.overlay = wrapper.querySelector('.popup-message-overlay');
    this.closeButton = wrapper.querySelector('.popup-message-close');
    this.container = wrapper.querySelector('.popup-message-container');
    
    this.delay = 3000;
    this.storageKey = 'hasVisitedLoomstatePopOver';
    this.checkParameter = wrapper.dataset.checkUrlParameter === 'true';
    this.expectedRefValue = wrapper.dataset.refValue || 'partner';
    
    this.init();
  }

  init() {
    this.setupEventListeners();
    
    if (this.shouldShowInitialPopup()) {
      this.scheduleShow();
    }
  }

shouldShowInitialPopup() {
  const hasVisited = localStorage.getItem(this.storageKey);
  let cameFromPartner = false;
  
  // If URL parameter check is enabled, verify if ref parameter matches expected value
  if (this.checkParameter) {
    cameFromPartner = this.hasMatchingRefParameter();
  }

  return cameFromPartner ? true : hasVisited ? false : true;
}

hasMatchingRefParameter() {
  const urlParams = new URLSearchParams(window.location.search);
  const refValue = urlParams.get('ref');
  
  return refValue === this.expectedRefValue;
}

  scheduleShow() {
    setTimeout(() => {
      this.show();
    }, this.delay);
  }

  show() {
    this.wrapper.classList.add('active');
    document.body.classList.add('popup-open');
    
    this.wrapper.offsetHeight;
    
    requestAnimationFrame(() => {
      this.wrapper.classList.add('visible');
    });

    setTimeout(() => {
      this.closeButton.focus();
    }, 300);

  }

hide() {
  this.wrapper.classList.remove('visible');
  
  setTimeout(() => {
    this.wrapper.classList.remove('active');
    document.body.classList.remove('popup-open');
  }, 300);

}

confirm() {
  localStorage.setItem(this.storageKey, 'true');
  this.hide();
}

  setupEventListeners() {
    this.closeButton.addEventListener('click', () => {
      this.hide();
    });

    this.overlay.addEventListener('click', () => {
      this.hide();
    });

    const cancelButtons = this.wrapper.querySelectorAll('.popup-close-trigger');
    cancelButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.hide();
      });
    });

    const confirmButtons = this.wrapper.querySelectorAll('.popup-confirm-trigger');
    confirmButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.confirm();
      });
    });

  }
}

document.addEventListener('DOMContentLoaded', () => {
  const popupWrappers = document.querySelectorAll('.popup-message-wrapper');
  popupWrappers.forEach(wrapper => {
    new PopupMessage(wrapper);
  });
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const wrapper = event.target.querySelector('.popup-message-wrapper');
    if (wrapper) {
      new PopupMessage(wrapper);
    }
  });
}
